import { useState } from 'react'
import {
  Alert,
  Box,
  Button,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import { authService } from '../services'
import { getApiErrorMessage } from '../services/apiClient'
import useAuthStore from '../store/authStore'
import { useNavigate } from 'react-router-dom'
import AdminPasswordRequirements from '../components/AdminPasswordRequirements'
import {
  getAdminPasswordPolicyError,
  isAdminPasswordValid,
} from '../utils/adminPasswordPolicy'

const ChangePasswordPage = () => {
  const navigate = useNavigate()
  const logout = useAuthStore((s) => s.logout)
  const [currentPassword, setCurrent] = useState('')
  const [newPassword, setNew] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [ok, setOk] = useState('')
  const [loading, setLoading] = useState(false)

  const canSubmit =
    Boolean(currentPassword) &&
    isAdminPasswordValid(newPassword) &&
    newPassword === confirm &&
    !loading

  const onSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setOk('')
    const policyError = getAdminPasswordPolicyError(newPassword)
    if (policyError) {
      setError(policyError)
      return
    }
    if (newPassword !== confirm) {
      setError('Passwords do not match.')
      return
    }
    setLoading(true)
    try {
      const res = await authService.changePassword(currentPassword, newPassword)
      setOk(res.message || 'Password changed.')
      logout()
      setTimeout(() => navigate('/login', { replace: true }), 1500)
    } catch (err) {
      setError(getApiErrorMessage(err, 'Could not change password.'))
      setLoading(false)
    }
  }

  return (
    <Box sx={{ p: 3, maxWidth: 520 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        Change password
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Box component="form" onSubmit={onSubmit}>
          {error ? (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          ) : null}
          {ok ? (
            <Alert severity="success" sx={{ mb: 2 }}>
              {ok}
            </Alert>
          ) : null}
          <TextField
            fullWidth
            required
            type="password"
            label="Current password"
            value={currentPassword}
            onChange={(e) => setCurrent(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            required
            type="password"
            label="New password"
            value={newPassword}
            onChange={(e) => setNew(e.target.value)}
            sx={{ mb: 1 }}
          />
          <AdminPasswordRequirements password={newPassword} />
          <TextField
            fullWidth
            required
            type="password"
            label="Confirm new password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Button type="submit" variant="contained" disabled={!canSubmit}>
            Update password
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}

export default ChangePasswordPage
